import React, {useState} from "react";
import {Drawer, Typography} from 'antd';
import LogoMobileIcon from "@components/svg/LogoIcon/LogoMobileIcon";
import {PATHS} from "@config/constants";

import "./index.scss";
import LeftMenu from "@components/LeftMenu";
import { useQuery } from "react-query";
import { getRemainTurnQuery, getUserQuery } from "dataLayer/user";
import UserBlock from "@components/LeftMenu/components/UserBlock";
import UserLogin from "@components/LeftMenu/components/UserLogin";
import logoNoText from "../../assets/icons/logo.svg"
import MenuDrawerIcon from "@components/svg/MenuDrawerIcon";

const {Link} = Typography;

const MenuMobile = () => {
  const { data: user, isLoading } = useQuery(getUserQuery());
  const { data: currentPack } = useQuery(getRemainTurnQuery());
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <>
      <div className="left-menu-mobile">
        <div className="left-menu-mobile-brand">
          <a className="left-menu-mobile-brand-icon" onClick={showDrawer}><MenuDrawerIcon/></a>
          <Link href={PATHS.BID_PAGE} className="brand-logo">
            <LogoMobileIcon
              className="brand-logo-text"
            />
            {/* <img src={logoNoText} /> */}
          </Link>
        </div>
        {isLoading ? (
          <></>
        ) : user ? (
          <UserBlock user={user} currentPack={currentPack} />
        ) : (
          <UserLogin />
        )}
      </div>
      <Drawer
        placement="left"
        closable={false}
        onClose={onClose}
        visible={visible}
        width={300}
        key="left">
        <LeftMenu />
      </Drawer>
    </>
  );
};

export default MenuMobile;
